import {
  FETCHED_PUBLISHED_LESSONS,
  LESSON_PUBLISHED,
  PUBLISHED_LESSON_DELETED,
} from 'app/models/publishedLessonAdmin/constants';

export const fetchedPublishedLessons = (lessonID, publishedIDs) => ({
  type:    FETCHED_PUBLISHED_LESSONS,
  payload: { lessonID, publishedIDs },
});

export const lessonPublished = (lessonID, publishedLessonID) => ({
  type:    LESSON_PUBLISHED,
  payload: { lessonID, publishedLessonID },
});

export const deletedPublishedLesson = (lessonID, publishedLessonID) => ({
  type:    PUBLISHED_LESSON_DELETED,
  payload: { lessonID, publishedLessonID },
});
